import * as tslib_1 from "tslib";
import { EventEmitter, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { BarVerticalComponent } from '@swimlane/ngx-charts';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var VerticalBarChartComponent = /** @class */ (function () {
    function VerticalBarChartComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.results = [];
        this.isLoading = true;
        this.xAxis = true;
        this.yAxis = false;
        this.roundEdges = true;
        this.showGridLines = false;
        this.rotateXAxisTicks = true;
        this.showDataLabel = true;
        this.yAxisTickFormatting = '2-digit';
        this.select = new EventEmitter();
        this.subscriptions = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    VerticalBarChartComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    VerticalBarChartComponent.prototype.ngOnInit = function () {
        var _this = this;
        var navbar = document.querySelector('fce-sidebar');
        fromEvent(navbar, 'toggleSidebar')
            .pipe(takeUntil(this.subscriptions), debounceTime(100), filter(function () { return !!_this.chart; }))
            .subscribe(function () { return _this.chart.update(); });
    };
    VerticalBarChartComponent.prototype.ngOnChanges = function (changes) {
        if (changes && changes.results && changes.results.currentValue) {
            this.results = changes.results.currentValue;
            this.hasData = this.results.some(function (item) {
                return item.value !== 0;
            });
        }
    };
    VerticalBarChartComponent.prototype.beforePrint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.chart.view = [600, 340];
                this.chart.update();
                return [2 /*return*/];
            });
        });
    };
    VerticalBarChartComponent.prototype.afterPrint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.chart.view = null;
                this.chart.update();
                return [2 /*return*/];
            });
        });
    };
    return VerticalBarChartComponent;
}());
export { VerticalBarChartComponent };
